var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        [_vm.$style.container]: true,
        [_vm.$style.tableOpen]: _vm.isTableOpen,
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "rbButton smallIcon",
          class: _vm.$style.button,
          on: {
            click: function ($event) {
              return _vm.$rbEmit("toggled")
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v(_vm._s(_vm.icon))])]
      ),
      _vm.label
        ? _c("div", { class: _vm.$style.label }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }